import { createSelector } from "@reduxjs/toolkit";
import { rootState } from "../../../../redux/store";

export const selectorWebsocket = createSelector(
    (state: rootState) => state.loginUserAndTokenData,
    (state: rootState) => state.project,
    (state: rootState) => state.hostAndUsername,
    (state: rootState) => state.savedUserToken,
    (state: rootState) => state.userSettingsFilePath,
    (state: rootState) => state.userSettingsAddProjectPath,


    (loginUserAndTokenData, project, hostAndUsername, savedUserToken, userSettingsFilePath, userSettingsAddProjectPath) => {
        return  {
            loginUserAndTokenData,
            project,
            hostAndUsername,
            savedUserToken,
            userSettingsFilePath,
            userSettingsAddProjectPath
        }
    }
);